import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Avatar } from './avatar.component';

export { Avatar } from './avatar.component';

@NgModule({
  declarations: [Avatar],
  exports: [Avatar],
  imports: [CommonModule]
})
export class AvatarModule { }
